module.exports = __webpack_public_path__ + "abcfa39ae37d0f7c242a404867522c50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/Fossil fuel stocks and bonds in 401ks.png
// module id = 1601
// module chunks = 0